module.exports = __webpack_public_path__ + "img/125.ac442553.png";